angular.module('impactx.configuration').service("BrowserSettings", function () {

    var cookiesEnabled = {
        value: navigator.cookieEnabled
    };

    var isGermanUser = {
        value: navigator.language.indexOf("de") > -1
    };

    return {
        cookiesEnabled: cookiesEnabled.value,
        isGermanUser: isGermanUser.value
    };
});